import { IReconBreakDetailData, IReconData } from 'api/recondata.types'
import { createListsStore } from 'features/Lists/core/store'
import { hookDefinitions } from 'features/Lists/hooks/useList/hookDefinitions'
import {
  createDefaultColumnState,
  mapColumnsToFilterDefinitions
} from 'features/Lists/shared/lists'
import { partial } from 'lodash/fp'
import { AppState } from 'store'
import { formatReconStatusLabel } from '../features/common/Utility'
import {
  ReconDataSummaryColumnDefinitions,
  ReconDataSummaryDefaultColumns
} from '../features/DashBoard/ColumnDefinitions'
import {
  BreakDetailDefaultColumns,
  BreakDetailColumnDefinitions
} from '../features/DashBoard/Suppressed/ColumnDefinitions'

export const constructInitialReconDataColumnState = partial(
  createDefaultColumnState,
  [ReconDataSummaryColumnDefinitions]
)
export const constructInitialSuppressColumnState = partial(
  createDefaultColumnState,
  [BreakDetailColumnDefinitions]
)

export const reconDataSummaryListStore = createListsStore<IReconData>(
  'dqrbreaksummary',
  '@features/@lists/@dqrbreaksummary',
  {
    columnDefinitions: ReconDataSummaryColumnDefinitions,
    filterDefinitions: mapColumnsToFilterDefinitions(
      ReconDataSummaryColumnDefinitions
    ),
    columnState: constructInitialReconDataColumnState(
      ReconDataSummaryDefaultColumns,
      1
    )
  },
  (state: AppState) => state.features.lists.reconDataSummary,
  undefined,
  { breakSummaryStatus: formatReconStatusLabel }
)

export const { reducer, sagas, actions, selectors } = reconDataSummaryListStore

// Register the recon list type with the core Lists system
hookDefinitions.recon = {
  listType: 'recon',
  columnDefinitions: ReconDataSummaryColumnDefinitions,
  actions,
  selectors
}

export const breakDetailListStore = createListsStore<IReconBreakDetailData>(
  'dqrbreakdetail',
  '@features/@lists/@dqrbreakdetail',
  {
    columnDefinitions: BreakDetailColumnDefinitions,
    filterDefinitions: mapColumnsToFilterDefinitions(
      BreakDetailColumnDefinitions
    ),
    columnState: constructInitialSuppressColumnState(
      BreakDetailDefaultColumns,
      1
    )
  },
  (state: AppState) => state.features.lists.breakDetailDataSummary
)

export const {
  breakDetailReducer,
  breakDetailSagas,
  breakDetailActions,
  breakDetailSelectors
} = breakDetailListStore

// Register the recon list type with the core Lists system
hookDefinitions.suppressed = {
  listType: 'suppressed',
  columnDefinitions: BreakDetailColumnDefinitions,
  actions: breakDetailActions,
  selectors: breakDetailSelectors
}
